import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { imageLoaderForStaticImages } from '../../context/utils'
import { useAppContext } from '../../context/siteMapContext'

interface IInfoProps {
  privacyPolicy: string
  sitemap: string
  accessibilityStatement: string
}

interface IInfoIconProps {
  iconName: string
  url: string
}

export const InfoIcon: React.FC<IInfoIconProps> = ({ iconName, url }) => {
  return (
    <Link href={url}>
      <a className='w-[18px] h-[18px] relative'>
        <Image
          loader={imageLoaderForStaticImages}
          alt={iconName}
          title={iconName}
          src={`/footer/Icon_${iconName}.svg`}
          layout='fill'
          objectFit='contain'
        />
      </a>
    </Link>
  )
}

const Info: React.FC<IInfoProps> = ({
  privacyPolicy,
  sitemap,
  accessibilityStatement,
}) => {
  const { highContrastOn, setHighContrastOn } = useAppContext()
  const { webmenus } = useAppContext()
  const privacy = Object.values(webmenus).find((x: any) => x.url_EN === '/privacypolicy');
  const accessibility = Object.values(webmenus).find((x: any) => x.url_EN === '/accessibilitystatement');

  const toggleHighContrastModel = () => {
    setHighContrastOn(!highContrastOn);
  }

  return (
    <div className='h-full text-footer-text-2xl font-montserrat font-medium flex flex-col gap-10'>
      <div className='h-1/2 pt-[16px] flex gap-20 justify-center 2xl:justify-end items-end items-center '>
        <Image
          className='cursor-pointer'
          loader={imageLoaderForStaticImages}
          alt='Megjelenítés gyengénlátóknak'
          title='Megjelenítés gyengénlátóknak'
          src={`/footer/Icon_high_contrast_icon.svg`}
          objectFit='cover'
          width={58}
          height={58}
          onClick={toggleHighContrastModel}
        />

      </div>
      <div className='h-full flex flex-col justify-start 2xl:justify-end items-center 2xl:items-end'>
        <Link href={`/general-list?webmenuId=${privacy?.id}`} as='adatvedelmi-iranyelvek' shallow>
          <a>{privacyPolicy || 'Adatkezelési tájékoztató'}</a>
        </Link>
        <br />
        <Link href='/sitemap' as='oldalterkep'>
          <a>{sitemap || 'Oldaltérkép'}</a>
        </Link>
        <br />
        <Link href={`/article?contentId=${accessibility?.id}`} as='akadalymentesitesi-nyilatkozat'>
          <a>{accessibilityStatement || 'Akadálymentesítési nyilatkozat'}</a>
        </Link>
      </div>
    </div>
  )
}

export default Info
